export default __webpack_public_path__ + "static/media/ios.279351da.svg";